import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_COMMENT_LIST } from "../services/get-comment-list";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_COMMENT_CATEGORIES_LIST } from "../services/get-comment-categories-list";
import { getFormatedDate } from "../../../../common_components/user-task-card-view/user-task-utils";
export const TOGGLE_ADD_COMMENT_POPUP = "TOGGLE_ADD_COMMENT_POPUP";
export const SET_COMMENT_FORM_DATA = "SET_COMMENT_FORM_DATA";
export const SET_COMMENT_END_DATE = "SET_COMMENT_END_DATE";
export const RESET_COMMENT_POPUP_VALIDATION = "RESET_COMMENT_POPUP_VALIDATION";
export const CLEAR_COMMENT_FORM_DATA = "CLEAR_COMMENT_FORM_DATA";

export const defaultCommentFormData = {
  commentId: 0,
  entityType: "Denial Predictor",
  entityId: 0,
  commentText: "",
  clientId: 0,
  applicationId: null,
  createDate: null,
  updateDate: null,
  categoryName: "",
  createdBy: "",
  updatedBy: "",
  deleted: 0,
};

const initialState = {
  isLoading: false,
  hasAllAuditGroupAccess: false,
  commentList: [],
  commentFormData: { ...defaultCommentFormData },
  initialCommentFormData: { ...defaultCommentFormData },
  categoryList: [],
};
export const commentCategoryData = {
  commentId: 0,
  entityType: "Denial Predictor",
  entityId: 0,
  commentText: "",
  clientId: 0,
  applicationId: null,
  createDate: null,
  updateDate: null,
  categoryName: "",
  createdBy: "",
  updatedBy: "",
  deleted: 0,
};
export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_ADD_COMMENT_POPUP:
    case RESET_COMMENT_POPUP_VALIDATION:
    case CLEAR_COMMENT_FORM_DATA:
    case SET_COMMENT_END_DATE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_COMMENT_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const initialCommentFormData = newState.commentFormData
          ? newState.commentFormData
          : {};
        for (let prop in action.data.commentFormData) {
          initialCommentFormData[prop] = action.data.commentFormData[prop];
        }
        newState = {
          ...newState,
          commentFormData: initialCommentFormData,
        };
      }
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_COMMENT_LIST)(action)) {
        return { ...state, commentList: [] };
      }
      if (isAsyncComplete(GET_COMMENT_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          commentList: response,
        };
      }

      if (isAsyncOperation(GET_COMMENT_CATEGORIES_LIST)(action)) {
        return {
          ...state,
          categoryList: [],
        };
      }
      if (isAsyncComplete(GET_COMMENT_CATEGORIES_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          categoryList: response,
        };
      }
      return state;
    default:
      return state;
  }
}

export const formatCommentObjectToDisplay = (commentFormData) => {
  if (!commentFormData) return {};
  commentFormData.categoryName = "";
  commentFormData.commentText = "";
  return commentFormData;
};

export const formatCommentObjectToSave = (
  commentFormData,
  amsFacsResponseId
) => {
  commentFormData = cloneDeep(commentFormData);
  commentFormData.entityId = amsFacsResponseId;
  commentFormData.applicationId = "MDAE";
  commentFormData.entityType = "Denial Predictor";
  commentFormData.createDate = getFormatedDate(new Date());
  commentFormData.updateDate = getFormatedDate(new Date());

  return commentFormData;
};
export const formatCommentCategoryDataObjectToSave = (
  commentCategoryData,
  amsFacsResponseId
) => {
  commentCategoryData = cloneDeep(commentCategoryData);
  commentCategoryData.entityId = amsFacsResponseId;
  commentCategoryData.applicationId = "MDAE";
  commentCategoryData.entityType = "Denial Predictor";
  commentCategoryData.createDate = getFormatedDate(new Date());
  commentCategoryData.updateDate = getFormatedDate(new Date());
  return commentCategoryData;
};

